import PropTypes from 'prop-types';
import React from 'react';

import './style.scss';

// @todo Is there not another way to get this path?
const providerImagePath = (provider, theme) => {
  const ext = 'png';
  // eslint-disable-next-line max-len
  return `/wp-content/themes/nexstar/client/src/images/tve/${provider}-${theme}.${ext}`;
};

/**
 * *Provisional* component for the Anvato video player.
 *
 * This component may be reworked in the future in part or in whole. Its current
 * purpose is to start developing connections between the global Redux store
 * and individual players.
 */
const AnvatoVideoPlayer = ({
  theme,
  tve,
}) => (
  <>
    {tve && (
      <div className="video-player__tve-branding">
        <a href={tve.link}>
          <img
            alt={tve.title}
            src={providerImagePath(tve.provider, theme)}
          />
        </a>
      </div>
    )}
  </>
);

AnvatoVideoPlayer.propTypes = {
  theme: PropTypes.string,
  tve: PropTypes.shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
  }),
};

AnvatoVideoPlayer.defaultProps = {
  theme: 'light',
  tve: null,
};

export default AnvatoVideoPlayer;
